import { TTypeOfCodec, TTypeOfNewDefault } from "../../../shared/src/codecs/codec";
import { formEditable, TFormEditableCodec } from "../../../shared/src/codecs/types/formEditable";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { string, TAnyStringCodec } from "../../../shared/src/codecs/types/string";
import { TAnyUuidCodec, uuid } from "../../../shared/src/codecs/types/uuid";
import { boolean, TAnyBooleanCodec } from "../../../shared/src/codecs/types/boolean";

const BuyerUpdatesConveyancerDetailsFields = required({
    enquiry_id: uuid(),
    conveyancer_organisation_name: string(),
    conveyancer_name: string(),
    conveyancer_phone_number: string(),
    conveyancer_email_address: string(),
    conveyancer_address: string(),
    conveyancer_confirmed_timeframe: boolean(),
});

type TBuyerUpdatesConveyancerDetailsFieldsCodec = TRequiredCodec<{
    enquiry_id: TAnyUuidCodec;
    conveyancer_organisation_name: TAnyStringCodec;
    conveyancer_name: TAnyStringCodec;
    conveyancer_phone_number: TAnyStringCodec;
    conveyancer_email_address: TAnyStringCodec;
    conveyancer_address: TAnyStringCodec;
    conveyancer_confirmed_timeframe: TAnyBooleanCodec;
}>;

export const BuyerUpdatesConveyancerDetailsFormEditable: TFormEditableCodec<TBuyerUpdatesConveyancerDetailsFieldsCodec> = formEditable(BuyerUpdatesConveyancerDetailsFields);

export type TBuyerUpdatesConveyancerDetailsFormEditableCodec = typeof BuyerUpdatesConveyancerDetailsFormEditable;

export type TBuyerUpdatesConveyancerDetailsFormEditable = TTypeOfCodec<TBuyerUpdatesConveyancerDetailsFormEditableCodec>;

export type TBuyerUpdatesConveyancerDetailsFormEditableNewDefault = TTypeOfNewDefault<TBuyerUpdatesConveyancerDetailsFormEditableCodec>;
